import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateVariantTypesMutation = createMutationHook(
  OffersApiClient.updateVariantTypes,
  { mutationKey: ['updateVariantTypes'] },
)
